import displayError from 'utils/displayError';
import { $list, $view } from 'signals/global.signals';
import { getOrgTeams } from 'api/teams.api';
import { getOrgPortfolio } from 'api/portfolio.api';

export const fetchAndSetTeamsOptions = async () => {
  try {
    const { data } = await getOrgTeams();

    const teamOptions = data.map((team) => ({
      label: team.name,
      value: team.id,
    }));

    $view.update({ teamOptions });
  } catch (error) {
    displayError({
      message: 'Failed to load team options. Please refresh the page.',
      title: 'Loading Error',
    });
  }
};

export const fetchAndSetPortfolioData = async () => {
  $view.update({
    isTableLoading: true,
    isLoading: true,
  });
  try {
    const { data } = await getOrgPortfolio();
    $list.update({ data });
  } catch (error) {
    displayError({
      message: 'Failed to load portfolio data. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({
      isTableLoading: false,
      isLoading: false,
    });
  }
};
